import { render } from "./DisplayRecords.vue?vue&type=template&id=25f88f9a&scoped=true"
import script from "./DisplayRecords.vue?vue&type=script&lang=js"
export * from "./DisplayRecords.vue?vue&type=script&lang=js"

import "./DisplayRecords.vue?vue&type=style&index=0&id=25f88f9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f88f9a"]])

export default __exports__